import Constants from 'common/constants'
import AuthModule from 'common/auth'

const LOGIN_ROUTE = '/login'

export function clearRedirectRoute() {
  sessionStorage.removeItem(Constants.REDIRECT_TO_LOCAL_STORAGE)
}

export function setRedirectRoute() {
  if (window.location.pathname !== LOGIN_ROUTE) {
    sessionStorage.setItem(
      Constants.REDIRECT_TO_LOCAL_STORAGE,
      window.location.pathname
    )
  }
}

export function getDefaultAuthenticatedRoute(): string {
  try {
    const auth = localStorage.getItem(Constants.AUTH_LOCAL_STORAGE)
    if (auth) {
      const jwt = AuthModule.parseJwt(JSON.parse(auth).accessToken)
      // Funcionario/admin primeiro: quem tambem e captador (ex.: ADMIN +
      // CAPTADOR) continua no painel do CRM.
      if (AuthModule.isAdmin(jwt) || AuthModule.isEmployee(jwt)) {
        return '/admin'
      }
      if (AuthModule.isCaptador(jwt)) {
        return '/captador'
      }
      if (AuthModule.isCustomer(jwt)) {
        return '/portal'
      }
    }
  } catch {}
  return '/admin'
}

export function getRedirectRoute(isAuthenticated: boolean) {
  const redirectRoute = sessionStorage.getItem(
    Constants.REDIRECT_TO_LOCAL_STORAGE
  )

  // Se não há rota de redirecionamento salva, usa a rota padrão
  if (!redirectRoute || redirectRoute === LOGIN_ROUTE) {
    return isAuthenticated ? getDefaultAuthenticatedRoute() : '/'
  }

  return redirectRoute
}
